import React from "react";

import {
  createEmptyExamDetail,
  createEmptyExamDetailObservation,
  EVetExamFields,
  examDetailsFields,
  FormField
} from "../../options";
import { checkSelectingFieldsOneEntry } from "../../helper";
import DetailsObservation from "./DetailsObservation";
import EntryItem from "../../EntryItem";
import VetExamFormField from "../../VetExamFormField/VetExamFormField";
import AddEntryButton from "../../AddEntryButton";
import { IExamDetail } from "../../options";
import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import { useVetExamContext } from "components/VetExamOverlay/VetExamProvider/VetExamProvider";
import useParentsStyles from "components/VetExamOverlay/styles";
import useStyles from "./styles";

interface IProps {
  examDetailsItem: IExamDetail;
  index: number;
}

const ADD_OBSERVATION_ENTRY = "Add Another Observation";

const ExamDetails = (props: IProps) => {
  const { examDetailsItem, index } = props;
  const detailObservations = examDetailsItem.observationEntries;

  const classes = useStyles();
  const parentsClasses = useParentsStyles();
  const {
    values: { examDetails },
    setFieldValue
  } = useVetExamContext();
  const { lockExam } = useExamLockerContext();

  const handleDelete = () => {
    const updatedDetails =
      examDetails.length === 1
        ? [createEmptyExamDetail()]
        : examDetails.filter(
            (detail: IExamDetail) => detail.id !== examDetailsItem.id
          );

    setFieldValue(EVetExamFields.EXAM_DETAILS, updatedDetails);

    lockExam();
  };

  const handleAddObservationEntry = () => {
    setFieldValue(
      EVetExamFields.EXAM_DETAILS,
      examDetails.map((detail: IExamDetail) => {
        if (detail.id === examDetailsItem.id) {
          return {
            ...detail,
            observationEntries: [
              ...detail.observationEntries,
              createEmptyExamDetailObservation()
            ]
          };
        }

        return detail;
      })
    );

    lockExam();
  };

  const renderField = (field: FormField) => {
    return (
      <VetExamFormField
        key={field.key}
        field={field}
        entryState={examDetailsItem}
      />
    );
  };

  const renderObservations = () => {
    return detailObservations.map((item, index) => (
      <DetailsObservation
        key={item.id}
        index={index + 1}
        detailId={examDetailsItem.id}
        observationItem={item}
      />
    ));
  };

  const isDeleteDetailButtonDisabled =
    index === 1 &&
    !checkSelectingFieldsOneEntry(examDetailsItem) &&
    !detailObservations.some(checkSelectingFieldsOneEntry);
  const isAddObservationEntryDisabled = !detailObservations.every(
    checkSelectingFieldsOneEntry
  );

  return (
    <EntryItem
      entryNumber={index}
      onDeleteEntry={handleDelete}
      disabledRemoveButton={isDeleteDetailButtonDisabled}
    >
      <div className={parentsClasses.fieldsWrapper}>
        {examDetailsFields.map(renderField)}
        {renderObservations()}
        <AddEntryButton
          className={classes.addEntryButton}
          title={ADD_OBSERVATION_ENTRY}
          onClick={handleAddObservationEntry}
          disabled={isAddObservationEntryDisabled}
        />
      </div>
    </EntryItem>
  );
};

export default ExamDetails;
